"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const nmr_processing_1 = require("nmr-processing");
const DefaultApodizationOptions_1 = require("../../data/constants/DefaultApodizationOptions");
const ChartContext_1 = require("../context/ChartContext");
const ScaleContext_1 = require("../context/ScaleContext");
const useActiveSpectrum_1 = require("../hooks/useActiveSpectrum");
const useSpectrum_1 = __importDefault(require("../hooks/useSpectrum"));
const useVerticalAlign_1 = require("../hooks/useVerticalAlign");
const useXYReduce_1 = __importStar(require("../hooks/useXYReduce"));
const PathBuilder_1 = require("../utility/PathBuilder");
const scale_1 = require("./utilities/scale");
const emptyData = { data: {}, info: {} };
function useWindowYScale() {
    const { height, margin, yDomains } = (0, ChartContext_1.useChartData)();
    const verticalAlign = (0, useVerticalAlign_1.useVerticalAlign)();
    return (0, scale_1.getYScale)({
        height,
        margin,
        verticalAlign,
        yDomain: [0, 1],
        yDomains,
    });
}
function ApodizationLine() {
    const { toolOptions: { selectedTool, data: { apodizationOptions }, }, } = (0, ChartContext_1.useChartData)();
    const activeSpectrum = (0, useActiveSpectrum_1.useActiveSpectrum)();
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    const spectrum = (0, useSpectrum_1.default)({ emptyData });
    const xyReduce = (0, useXYReduce_1.default)(useXYReduce_1.XYReducerDomainAxis.XAxis);
    const scaleY = useWindowYScale();
    if (!activeSpectrum?.id || selectedTool !== nmr_processing_1.Filters.apodization.id) {
        return null;
    }
    const paths = () => {
        const pathBuilder = new PathBuilder_1.PathBuilder();
        const { re, im = [], x } = spectrum.data;
        const { lineBroadening, gaussBroadening, lineBroadeningCenter } = apodizationOptions || DefaultApodizationOptions_1.defaultApodizationOptions;
        const length = re.length;
        const dw = (x[length - 1] - x[0]) / (length - 1);
        const { windowData: y } = (0, nmr_processing_1.apodization)({ re, im }, {
            apply: false,
            compose: {
                length,
                shapes: [
                    {
                        start: 0,
                        shape: {
                            kind: 'lorentzToGauss',
                            options: {
                                length,
                                dw,
                                exponentialHz: gaussBroadening > 0 ? lineBroadening : -lineBroadening,
                                gaussianHz: gaussBroadening,
                                center: lineBroadeningCenter,
                            },
                        },
                    },
                ],
            },
        });
        if (x && y) {
            const pathPoints = xyReduce({ x, y });
            pathBuilder.moveTo(scaleX()(pathPoints.x[0]), scaleY(pathPoints.y[0]));
            for (let i = 1; i < pathPoints.x.length; i++) {
                pathBuilder.lineTo(scaleX()(pathPoints.x[i]), scaleY(pathPoints.y[i]));
            }
            return pathBuilder.toString();
        }
        else {
            return '';
        }
    };
    return ((0, jsx_runtime_1.jsx)("path", { "data-testid": "apodization-line", stroke: "green", fill: "none", strokeWidth: "2", d: paths() }));
}
exports.default = ApodizationLine;
